export const FETCH_CONSIGNMENT_REQUEST = 'FETCH_CONSIGNMENT_REQUEST';
export const FETCH_CONSIGNMENT_SUCCESS = 'FETCH_CONSIGNMENT_SUCCESS';
export const FETCH_CONSIGNMENT_FAILURE = 'FETCH_CONSIGNMENT_FAILURE';
